<template>
<div v-if="hasRole(roles.RW_REAL_ESTA_CRED)">
  <div class="row d-flex" v-if="!flDetails">
    <div class="col-md-3">
      <formSales v-on:SearchItems="GetFilter" :selectedComissao="selectedComissao" :flFilterFolder="false"></formSales>
    </div>
    <div class="col-md-9">
      <div>
        <tableSales ref="tableCommissionCheck" :key="tablereload" v-on:edit="edit" v-on:deleteCommission="deleteCommission"></tableSales>
      </div>
    </div>
 </div>
  <DetailsSales :selectedComissao="selectedComissao" v-if="flDetails" v-on:edit="edit" v-on:deleteCommission="deleteCommission">></DetailsSales>
</div>

</template>

<script>

import salesinquiry from '@/views/private/realestate/salesinquiry/salesinquiry'
export default salesinquiry

</script>

<style scoped>

#form-seacch{
  display: flex;
  flex-direction: column;
  align-content: center;
}

.periodos{
 display: flex;
 flex-wrap: wrap;
 justify-content: space-around;

}

.arrow-angel{
  padding-top: 10px;
  font-size: 30px;
  color: black;
  padding-right: 24px;
}

.acording{
  display: flex;
  justify-content: space-between;
  padding-left: 20px;
  background-color: #ECEFF1;
  border-radius: 0px;
  height: 50px;
  width: 100%;
}
.mes{
  font-size: 22px;
  color: black;
  padding-top: 16px;
  font-weight: bold;
}

.footer{
  margin-bottom: 10%;
}

.btn-periodos{
  background-color: #EBEBEB;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: grey;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.btn-periodos-active{
   background-color: #008148;
  height: 30px;
  margin-top: 5px;
  margin-bottom: 5px;
  width: 130px;
  font-weight: bold;
  color: white;
  border-radius: 25px;
  padding: 5px;
  border: 1px solid rgb(77, 77, 77);
}

.labelseach{
  margin-bottom: 3px;
  font-size: 14px;
  font-weight: bold;
}

#card-sales{
  width: 100%;
  padding: 15px;
  border: 1px solid rgb(180, 180, 180);
  background-color: white;
}
#img-card-sales{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

#img-card{
  height: 300px;
  width: 300px;
  object-fit: contain;
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/salesinquiry/salesinquiry.vue